import { render, staticRenderFns } from "./DeleteForever.vue?vue&type=template&id=3c0c121b&"
import script from "./DeleteForever.vue?vue&type=script&lang=js&"
export * from "./DeleteForever.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports